import { Observable } from 'rxjs';
import type {
  Asset,
  AssetCreatedInfo,
  AssetDeletedInfo,
  AssetUpdatedInfo
} from '../models/asset.model';

/**
 * Stable domain contract for asset CRUD operations.
 * Implemented by AdessoAssetApiAdapter against the adesso-connector-api.
 */
export abstract class AssetApiPort {
  abstract getAssets(): Observable<Asset[]>;
  abstract createAsset(asset: Asset): Observable<AssetCreatedInfo>;
  abstract updateAsset(asset: Asset): Observable<AssetUpdatedInfo>;
  abstract deleteAsset(id: string): Observable<AssetDeletedInfo>;
}
